import { isRejected, Middleware } from '@reduxjs/toolkit';
import { logw } from '@shared/utils/utils_logs';
import { RootState } from '../store';

export const middleware_log_rejected_state: Middleware<{}, RootState> = storeAPI => next => action => {
  if (isRejected(action)) {
    logw(`action rejected\t${action.type}`);
    logw(`${action.error.name}`);
    logw(`${action.error.stack}`);
    logw(`${action.error.message}`);
  }

  const out = next(action);

  return out;
};
